// @ts-check

/**
 * @typedef RouteListItem
 * @property {string} id
 * @property {string} path
 * @property {string} name
 * @property {boolean} [isPublic=false]
 */

export const routesList = {
	home: {
		id: "home",
		path: "/",
		name: "Inicio",
		isPublic: true,
	},

	register: {
		id: "register",
		path: "/register",
		name: "Registro",
		isPublic: true,
	},
	login: {
		id: "login",
		path: "/login",
		name: "Iniciar sesión",
		isPublic: true,
	},
	logout: {
		id: "logout",
		path: "/logout",
		name: "Cerrar sesión",
		isPublic: true,
	},
	repair: {
		id: "repair",
		path: "/repair",
		name: "Reparar aplicación",
		isPublic: true,
	},
	magicLink: {
		id: "magicLink",
		path: "/magicLink",
		name: "Magic link",
		isPublic: true,
	},

	// Legal
	legalPrivacy: {
		id: "legalPrivacy",
		path: "/legal/privacy",
		name: "Política de privacidad",
		isPublic: true,
	},
	legalCookies: {
		id: "legalCookies",
		path: "/legal/cookies",
		name: "Política de cookies",
		isPublic: true,
	},
	legalTerms: {
		id: "legalTerms",
		path: "/legal/terms",
		name: "Términos y condiciones",
		isPublic: true,
	},

	crewInvitation: {
		id: "crewInvitation",
		path: "/crew-invitation",
		name: "Invitación a espacio",
	},

	dashboard: {
		id: "dashboard",
		path: "/dashboard",
		name: "Dashboard",
	},

	// Apps
	items: {
		id: "items",
		path: "/items",
		name: "Items",
	},

	money: {
		id: "money",
		path: "/money",
		name: "Inicio",
	},
	moneyMovements: {
		id: "moneyMovements",
		path: "/money/movements",
		name: "Movimientos",
	},
	moneySearch: {
		id: "moneySearch",
		path: "/money/search",
		name: "Buscar movimientos",
	},

	tasks: {
		id: "tasks",
		path: "/tasks",
		name: "Tareas",
	},
	tasksList: {
		id: "tasksList",
		path: "/tasks/list",
		name: "Lista de tareas",
	},

	split: {
		id: "split",
		path: "/split",
		name: "Split",
	},
	splitGroup: {
		id: "splitGroup",
		path: "/split/:shortId",
		name: "Grupo Split",
	},

	recipes: {
		id: "recipes",
		path: "/recipes",
		name: "Recetas",
	},
	recipeDetail: {
		id: "recipeDetail",
		path: "/recipes/:id",
		name: "Receta",
	},
	recipeShare: {
		id: "recipeShare",
		path: "/share/recipe/:token",
		name: "Compartir receta",
		isPublic: true,
	},

	// Onboarding
	onboardingGroup: {
		id: "onboardingGroup",
		path: "/onboarding/group",
		name: "Espacio",
	},

	// Settings
	settings: {
		id: "settings",
		path: "/settings",
		name: "Ajustes",
	},

	usage: {
		id: "usage",
		path: "/usage",
		name: "Uso",
	},
};

/**
 *
 * @param {string} path
 * @returns {boolean}
 */
export function isPublicPath(path) {
	const pathSegments = path.split("/");

	for (const _key in routesList) {
		// @ts-expect-error
		const route = routesList[_key];

		if (route.path === path) {
			return Boolean(route.isPublic);
		}

		// Segment match: ":param" route segments act as wildcards
		// (e.g. /share/recipe/:token matches /share/recipe/AbC123...)
		const routeSegments = route.path.split("/");

		if (routeSegments.length !== pathSegments.length) {
			continue;
		}

		const matches = routeSegments.every(
			(/** @type {string} */ _segment, /** @type {number} */ _i) =>
				_segment.startsWith(":") || _segment === pathSegments[_i],
		);

		if (matches) {
			return Boolean(route.isPublic);
		}
	}

	return false;
}
